import { createContext, useContext, useState, useEffect } from 'react'
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
} from 'firebase/auth'
import { auth } from '../lib/firebase'
import { setSentryUser, clearSentryUser } from '../lib/sentry'
import { setAnalyticsUser, trackLogin, trackSignUp } from '../lib/analytics'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser)
      setLoading(false)
      if (firebaseUser) {
        setSentryUser(firebaseUser.uid, firebaseUser.email)
        setAnalyticsUser(firebaseUser.uid)
      } else {
        clearSentryUser()
      }
    })
    return unsubscribe
  }, [])

  async function login(email, password) {
    const result = await signInWithEmailAndPassword(auth, email, password)
    trackLogin()
    return result
  }

  async function signup(email, password) {
    const result = await createUserWithEmailAndPassword(auth, email, password)
    trackSignUp()
    return result
  }

  async function logout() {
    clearSentryUser()
    return signOut(auth)
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used within an AuthProvider')
  return context
}
